function artHeader() {
  $(".art-header").insertAfter(".breadcrumbs-wrapper").wrapInner('<div class="container"/>'),
  $("article h1").prependTo(".art-header > div");
  $('.id-29 #content-wrapper').css('opacity','1');
}
function kontaktyPage() {
  0 == $(".art-header .contact-box").length && $("#footer .contact-box, #footer .custom-footer .social-reviews .social").clone().appendTo(".art-header > .container"),
  $("<span>" + dobaVolani + "</span>").appendTo(".svihaci-cards > div .text > a.telefon")
}
function funkceLoad() {
  $(".prem-header a").on("click", function(e) {
    e.preventDefault();
    var t = $(this).attr("href");
    $(".prem-header a").removeClass("active"),
    $(this).addClass("active"),
    $.get(t, function(e) {
      var t = $($.parseHTML(e));
      $(".prem-obsah").html(t.find("article > div"))
    }, null, "html")
  }),
  $(".prem-header a:first-child").click()
}

$(".art-header").length && artHeader(),
$(".id-29").length && kontaktyPage()

if ($('.in-svihej-portal').length) {
  $('.art-header').css('opacity','1');
  $('#content-wrapper').css('opacity','1');
  $('.reels-wrap').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint:1199,
        settings: {
          slidesToShow:3.5
        }
      },
      {
        breakpoint:991,
        settings: {
          slidesToShow:3 
        }
      },
      {
        breakpoint:479,
        settings: {
          slidesToShow:1.2
        }
      }
    ]
  });
}

$(".prem-header").length && funkceLoad()